import { HRM1060_R01Dto } from './Dto_HRM1060_R01';

/** 신청 상태 코드이다. */
export const CERT_STS_REQUEST = '10';
/** 출력 후 발급 상태 코드이다. */
export const CERT_STS_ISSUED = '20';
/** 취소 상태 코드이다. */
export const CERT_STS_CANCEL = '90';
/** 허용 최소 매수이다. */
export const MIN_COPIES = 1;
/** 허용 최대 매수이다. */
export const MAX_COPIES = 10;
/** 아직 출력하지 않은 시각의 DB 표식이다. */
export const UNPRINTED_DATE_PREFIX = '1900-01-01';

/** 출력 횟수를 기준으로 잠금 여부를 판단한다. @param row 대장 행 @returns true이면 한 번 이상 출력함 */
export const isHRM1060_R01Printed = (row: HRM1060_R01Dto): boolean => row.printCnt > 0;

/** 그리드 컬럼 필드와 표시명을 연결한다. */
export const headerNames_HRM1060_R01: Record<string, string> = {
    rowIndex: '', certNo: '발급번호', issueDt: '발급일자', empNo: '사원번호', empNm: '사원명',
    certType: '증명서', purpose: '용도', submitTo: '제출처', copies: '매수',
    issueSts: '상태', printCnt: '출력', lastPrintDt: '최종 출력',
};
